/* eslint-disable */

export const TK_ACTION_INIT = 'Iniciar';

export const TK_CATEGORY_SERVICE_SELECT = 'SELECAO-SERVICO';
export const TK_CATEGORY_BEHAVIOR = 'COMPORTAMENTO';
export const TK_CATEGORY_PROFILE = 'PERFIL';
import configuration from '../envConfig';

export const oracleCXAsyncLoader = () => {
    if(configuration.ambiente === 'development') {
        setTimeout(oracleCxLibLoader,2000)
    }
};

export const oracleCxLibLoader = () => {
    window.oracleInfinity = window.oracleInfinity || [];
    (function() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = configuration.oracleInfinityUrl;
        var firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    })();
}

const baseTrackEvent = (category, action,name,value) =>{
    (function () {
        var cxDataObject = {
            "wt.event_name": category,
        }

        if (action) {
            cxDataObject["wt.event_action"] = action;
            if (name && name != "") {
                cxDataObject["wt.service_name"] = name;
                if (value) {
                    cxDataObject["wt.event_value"] = value;
                }
            }
        }

        window.ORA = window.ORA || { productReady: [] };
        ORA.productReady.push(['analytics', function (cxDataObject) { return function () { return ORA.click({ "data": cxDataObject }) } }(cxDataObject)]);
    })();
};

export const trackServiceSelect = (action,name,value) =>{baseTrackEvent(TK_CATEGORY_SERVICE_SELECT, action, name, value) }
export const trackBehavior = (action,name,value) =>{baseTrackEvent(TK_CATEGORY_BEHAVIOR, action, name, value) }
export const trackProfile = (action,name,value) =>{baseTrackEvent(TK_CATEGORY_PROFILE, action, name, value) }

export const trackGoal = (idGoal,renevue )=>{
    let goal=['trackGoal', idGoal]
    if( renevue ){
        goal.push(renevue)
    }
    let p=window._paq?window._paq:[];
    p.push(goal)
}
